import config from '@/config';
import createApiClient from './api-client';

export default createApiClient(config.VUE_APP_REST_API_URL);
